import { render } from "./ArtigoTransferOrdem.vue?vue&type=template&id=58cfb1bb&scoped=true"
import script from "./ArtigoTransferOrdem.vue?vue&type=script&lang=js"
export * from "./ArtigoTransferOrdem.vue?vue&type=script&lang=js"

import "./ArtigoTransferOrdem.vue?vue&type=style&index=0&id=58cfb1bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cfb1bb"]])

export default __exports__